<script>
    export let name;
    export let latency='0';
    export let loop_adjustment = '0';
    export let audioContextState = null;
    export let isBlink = false;
    export let beat = 1;
    export let progress = 0;
    export let globalOffset = 0;
    export let recordingChannel = null;

    function addToGlobalOffset(_offset) {
      return function(e){
        globalOffset += _offset
      }
    }

    function loadSample(href) {
        return async function(e) {
            const response = await fetch(href);
            const bytes = await response.arrayBuffer();
            await initBuffer(bytes);
            return false;
        }
    }

    function handleStateChange(e) {
        audioContextState = e.currentTarget.state
    }

    let metronomeStyle = {
        border: '2px solid black',
        height: '38px',
        width: '38px',
        'border-radius': '20px',
        'display': 'none', // 'flex',
        'justify-content':'center'
    };

    let mainLoopSource = null;
    let classNames = [];
    let mediaRecorder;
    let pendingRecording = false;
    let isRecording = false;
    let chunks = [];

    $: classNamez = classNames.join(' ')
    $: cssVarStyles = Object.entries(metronomeStyle)
        .map(([key, value]) => `${key}:${value}`)
        .join(';');

    const audioContext = new AudioContext();
    audioContext.addEventListener('statechange', handleStateChange);

    function removeBlink() {
        isBlink = false;
    }

    async function playBlob(blob) {
        const buffer = await blob.arrayBuffer();
        await playBuffer(buffer);
    }

    function handleMainLoopEnded(e) {
        // mediaRecorder.requestData();
        console.log(`Main loop ended. Restarting ${sources} sources`)
        initMainLoop(mainLoopSource.buffer);
        console.log(`Starting ${sources.length} sources`)
        sources.forEach(x => playSource(x))
    }

    let loopStarted = 0;

    async function initMainLoop(audioBuffer) {
        loopStarted = audioContext.currentTime;
        if(mediaRecorder.state === 'recording')
          mediaRecorder.stop();
        if(name === 'pending') {
          name = 'recording'
          shouldSave = true
        }
        mediaRecorder.start();
        console.log('initMainLoop at ', loopStarted);
        // const audioBuffer = await audioContext.decodeAudioData(arrayBuffer)
        const source = audioContext.createBufferSource();
        source.buffer = audioBuffer;

        source.connect(audioContext.destination);

        mainLoopSource = source;
        mainLoopSource.addEventListener('ended', handleMainLoopEnded)
        mainLoopSource.start()
    }

    async function playSource(source) {
        await playBuffer(source.buffer);
    }

    async function playBuffer(audioBuffer){
        if(audioBuffer === undefined) {
          throw Error('CUNT!');
        }
        // const arrayBuffer = await blob.arrayBuffer();
        // const audioBuffer = await audioContext.decodeAudioData(arrayBuffer)
        const source = audioContext.createBufferSource();

        source.buffer = audioBuffer;

        source.connect(audioContext.destination);
        let nowInLoop = audioContext.currentTime - loopStarted
        let offset = nowInLoop + audioContext.baseLatency + globalOffset
        if(offset < 0) {
          console.warn('Offset must be larger than 0');
          offset = 0
        }
        source.start(0, offset);
        console.log(`Source started with offset ${offset}`)
    }


    async function initBuffer(arrayBuffer){
        if(mainLoopSource === null) {
            const audioBuffer = await audioContext.decodeAudioData(arrayBuffer)
            initMainLoop(audioBuffer);
            return;
        }

        const audioBuffer = await audioContext.decodeAudioData(arrayBuffer)
        const source = audioContext.createBufferSource();

        source.buffer = audioBuffer;

        // source.connect(audioContext.destination);
        sources.push(source)
        playSource(source)
    }

    let lastRun = performance.now();
    let firstBeat = lastRun;
    const loop = () => {
        // if(audioContext)
            // console.log(audioContext.currentTime)
        // console.log('wtf')
        setTimeout(()=>{
          window.requestAnimationFrame(loop);
        }, 100);
        
        if(performance.now() - lastRun >= 200) {
            let sourceCurrentTime = (audioContext.currentTime - loopStarted)
            if(mainLoopSource) {
                progress = (sourceCurrentTime / mainLoopSource.buffer.duration) * 100;
            }
            // console.log(sourceCurrentTime);
            isBlink = true;
            lastRun = performance.now();
            if(beat === 1) {
                firstBeat = lastRun;
                window.dispatchEvent(new CustomEvent('loopbegin'))
            }
            if(beat === 4) {
                beat = 1;
            } else {
                beat++;
            }
        }
    }
    window.requestAnimationFrame(loop);
    let lastLoopStart = 0;
    let offset = 0;
    let sources = [];
    let isFirstRecording = true;
    let shouldSave = false;


    function handleClick(channel) {
      return function(e) {
        if(recordingChannel == channel) {
          recordingChannel = null;
        }
        else {
          recordingChannel = channel;
        }
      
        offset = audioContext.currentTime - loopStarted

        if(mainLoopSource === null) {
            shouldSave = true
            if(mediaRecorder.state === 'recording') {
                mediaRecorder.stop();
                // name = mediaRecorder.state;	
                return;
            }

            mediaRecorder.start();
            // offset = performance.now() - lastLoopStart
            // name = mediaRecorder.state;
            // console.log("recorder started");
            
        } else {
          shouldSave = progress < 30

          if(shouldSave) {
            name = 'recording'
          } else {
            name='pending'
          }
        }        
      }
    }

    let mainSource = null;

    if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
        console.log('getUserMedia supported.');
        navigator.mediaDevices.getUserMedia (
            // constraints - only audio needed for this app
            {
                audio: true
            })

            // Success callback
            .then(function(stream) {
                mediaRecorder = new MediaRecorder(stream);
                mediaRecorder.addEventListener('dataavailable', async function(e) {

                  if(!shouldSave || recordingChannel === null) {
                    console.log(`shouldSave: ${shouldSave}`)
                    if(mainLoopSource !== null)
                      return ;
                  }

                  let _chunks = [e.data];
                    const blob = new Blob(_chunks, {'type': 'audio/ogg; codecs=opus'})
                    const arrayBuffer = await blob.arrayBuffer();
                    if(mainLoopSource === null) {
                      const audioBuffer = await audioContext.decodeAudioData(arrayBuffer)
                      initMainLoop(audioBuffer);
                      return;
                  }

                    initBuffer(arrayBuffer);
                    // const audioBuffer = await audioContext.decodeAudioData(arrayBuffer)
                    // const source = audioContext.createBufferSource();
                    // source.buffer = audioBuffer;
                    // debugger;
                    // sources.push(source)
                    // console.log(`added ${e.data.size} bytes of data`)
                });
                // mediaRecorder.start();
                return;
                mediaRecorder.addEventListener('stop', async function() {
                    isRecording = false;
                    const blob = new Blob(chunks, {'type': 'audio/ogg; codecs=opus'})
                    
                    const arrayBuffer = await blob.arrayBuffer();
                    const audioBuffer = await audioContext.decodeAudioData(arrayBuffer)
                    const source = audioContext.createBufferSource();

                    // chunks = [];
                    
                  if(mainLoopSource === null){
                    initMainLoop(audioBuffer);
                  }
                  return;
                    if(isFirstRecording) {
                        isFirstRecording = false;

                        // source.loop = true;
                        source.addEventListener('ended', function handleEnded(e) {
                            if(isRecording) {
                                mediaRecorder.stop();
                            }

                            if(pendingRecording) {
                                pendingRecording = false;
                                isRecording = true;
                                mediaRecorder.start();
                            }
                            let currentTime = audioContext.currentTime;
                            let replacementSources = [];
                            let first = null;
                            for(let {buffer, offset} of sources) {
                                // console.log('buffah! ' + buffer.length + ' ohfset! ' + offset);
                                const replacementSource = audioContext.createBufferSource();
                                offset = audioContext.baseLatency;
                                if(first === null) {
                                    first = replacementSource
                                    offset = 0
                                }
                                replacementSource.buffer = buffer;
                                replacementSource.connect(audioContext.destination);
                                if(offset === 0) {
                                    let l = parseInt(loop_adjustment);
                                    console.log(l)
                                    replacementSource.start(currentTime + (l === NaN ? 0 : l));
                                } else {
                                    let l = parseInt(latency);
                                    console.log(l)
                                    if(l !== NaN)
                                        replacementSource.start(currentTime - (audioContext.baseLatency +  + (l === NaN ? 0 : l)));
                                    else {
                                        replacementSource.start(currentTime - audioContext.baseLatency);
                                    }
                                }
                                
                                // replacementSources.push(replacementSource);
                                lastLoopStart = performance.now()
                                console.log('lastLoopStart: ' + lastLoopStart)
                            }
                            // sources = replacementSources;
                            first.addEventListener('ended', handleEnded, {once: true, capture:false})
                            // source.start();
                            // sources.forEach(x => x.start(x.offset))
                        }, {once: true, capture:false});
                        lastLoopStart = performance.now()
                        console.log('lastLoopStart: ' + lastLoopStart)
                        sources.push({
                            buffer: audioBuffer,
                            offset: 0
                        });
                    } else {
                        // let offset = performance.now() - lastLoopStart
                        console.log(`Got recording no ${sources.length + 1} with ${offset} ms offset`)
                        // const source = audioContext.createBufferSource();
                        // source.buffer = audioBuffer;

                        sources.push({
                            buffer: audioBuffer,
                            offset: 0
                        });
                    }
                    source.buffer = audioBuffer;
                    source.start()
                    // console.log(audioContext.baseLatency)
                        source.connect(audioContext.destination);
                        // source.start(audioContext.currentTime > 0 ? audioContext.currentTime - audioContext.baseLatency: 0);
                });
                console.log('success!')	
            })
            
            // Error callback
            .catch(function(err) {
                console.log('The following getUserMedia error occurred: ' + err);
            }
        );
    } else {
        console.log('getUserMedia not supported on your browser!');
    }
</script>

<main>
  <link rel="preconnect" href="https://fonts.googleapis.com" />
  <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin />
  <link
    href="https://fonts.googleapis.com/css2?family=Yesteryear&display=swap"
    rel="stylesheet"
  />
  <div id="stomper">
    <h1 style="color:silver; font-family:Yesteryear">STOMPLOOPER</h1>
    <h3>{name} {recordingChannel}</h3>
    <div class="panel-offset">
    <button class="btn-offset" on:click={addToGlobalOffset(-.01)}>-</button><div class="disp-offset">{globalOffset.toFixed(2)}</div><button class="btn-offset" on:click={addToGlobalOffset(+.01)}>+</button>
  </div>
    <div class="stomper-upper">
      <div class="stomper-left" />
      <div class="stomper-center">
        <div id="progress">
          <div id="progress-indicator" style="--progress:{progress}%" />
        </div>
      </div>
      <div class="stomper-right" />
    </div>
    <div class="stomper-lower">
      <div class="stomper-channel">
        <div class="indicator indicator-1" />
        <button
          class:pendingRecording
          class:is_recording={recordingChannel === 1}
          on:click={handleClick(1)}>1</button
        >
      </div>
      <!-- <div class="stomper-channel">
        <div class="indicator indicator-2" />
        <button
          class:pendingRecording
          class:is_recording={recordingChannel === 2}
          on:click={handleClick(2)}>2</button
        >
      </div>
      <div class="stomper-channel">
        <div class="indicator indicator-3" />
        <button
          class:pendingRecording
          class:is_recording={recordingChannel === 3}
          on:click={handleClick(3)}>3</button
        >
      </div>
      <div class="stomper-channel">
        <div class="indicator indicator-4" />
        <button
          class:pendingRecording
          class:is_recording={recordingChannel === 4}
          on:click={handleClick(4)}>4</button
        >
      </div> -->
    </div>
    <div
      on:animationend={removeBlink}
      class:blink={isBlink}
      class={classNamez}
      style={cssVarStyles}
    >
      <div class="beat">{beat}</div>
    </div>
  </div>
  <ul>
    <li>
      <a
        href="#!/"
        on:click={loadSample(
          "//loopnlearn.constructions.se.s3-website.eu-north-1.amazonaws.com/samples/stream.mp3"
        )}>Drums</a
      >
    </li>
    <li>
      <a
        href="#!/"
        on:click={loadSample(
          "//loopnlearn.constructions.se.s3-website.eu-north-1.amazonaws.com/samples/looperman-l-1314288-0272843-ken-carson-kankan-mando-nightclub20xx.mp3"
        )}>Drums</a
      >
    </li>
    <li>
      <a
        href="#!/"
        on:click={loadSample(
          "//loopnlearn.constructions.se.s3-website.eu-north-1.amazonaws.com/samples/looperman-l-1791281-0270449-0xcbf0917d.mp3"
        )}>Drums</a
      >
    </li>
  </ul>

  <p>
    Visit the <a href="https://svelte.dev/tutorial">Svelte tutorial</a> to learn
    how to build Svelte apps.
  </p>
  <p>
    <a
      href="https://developer.mozilla.org/en-US/docs/Web/API/Web_Audio_API/Using_Web_Audio_API"
      >Using Web Audio API</a
    >
  </p>
  <input bind:value={loop_adjustment} />
  <input bind:value={latency} />
</main>

<style>
  main {
    text-align: center;
    padding: 1em;
    max-width: 240px;
    margin: 0 auto;
  }

  #stomper {
    background: darkred;
    border: 2px solid black;
    border-radius: 40px;
    min-height: 400px;
    display: flex;
    flex-direction: column;
  }

  .stomper-upper {
    display: flex;
    /* padding-top: 20px */
  }

  .stomper-left,
  .stomper-right {
    min-width: 100px;
  }

  .stomper-center {
    flex-grow: 1;
  }

  .stomper-lower {
    display: flex;
    width: 100%;
    justify-content: space-around;
    flex-grow: 1;
    place-items: center;
  }
  .stomper-channel {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-around;
  }
  .stomper-channel button {
    background-color: black;
    color: silver;
    font-size: 60px;
    border-radius: 5px;
    border-color: black;
    margin-top: 20px;
  }

  @media (min-width: 640px) {
    main {
      max-width: none;
    }
  }

  #progress {
    width: 100%;
    background-color: #333;
    height: 2em;
    border: 1px solid black;
    border-radius: 5px;
    overflow: hidden;
  }

  #progress-indicator {
    width: var(--progress, 0%);
    height: 100%;
    background-color: orange;
    transition: width 0.3s;
  }
  /* The animation code */
  @keyframes example {
    from {
      color: white;
      background-color: rgb(29, 141, 29);
    }
    30% {
      color: white;
      background-color: rgb(29, 141, 29);
    }
    to {
      color: inherit;
      background-color: inherit;
    }
  }
  .indicator {
    height: 30px;
    width: 30px;
    border: 2px solid black;
    border-radius: 17px;
    background-color: #333;
  }
  .blink {
    /* background-color: red; */
    animation-name: example;
    animation-duration: 0.2s;
  }
  .beat {
    place-self: center;
  }
  .pendingRecording {
    background-color: palegoldenrod;
  }

  .is_recording {
    background-color: red;
  }

  .panel-offset {
    display:flex;
    align-items: center;
    justify-content: center;
  }
  
  .disp-offset{
    width: 100px;
    height: 50px;
    background-color: #333;
    border-radius: 8px;
    margin: 12px 0;
    color: silver;
    font-size: 2em;
    font-weight: bold;
    display:flex;
    place-content: center;
    place-items: center;
  }

  .btn-offset {
    width: 36px;
    height: 36px;
    margin: 0 12px;
    border-radius: 19px;
    border: 1px solid black
  }
</style>
